import React, { lazy, Suspense } from 'react'
import Loader from './components/Loader'
// import Navbar from './components/Navbar'
// import Home from './screen/Home'
const Home = lazy(() => import('./components/Navbar'))

const App = () => {
  return (
    <>
    <Suspense fallback={<Loader/>}>
      <Home />
    </Suspense>
    </>
  )
}

export default App
